
import { EmailBrandingViewModel } from '@/entities/OrganizationalSettings/EmailBrandingViewModel';
import EmailListingsModel from '@/entities/OrganizationalSettings/EmailListingsModel';
import EmailBrandingHelper from '@/helper/EmailBrandingHelper';
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';

@Component({
  components: {
  },
})
class EmailBrandingListings extends Vue {
  @Prop() emailDomainListings!: EmailBrandingViewModel[];
  @Prop() premiumFeatureEnabled!: boolean;
  private threeDotsIcon = require('@/assets/Images/three-dot-icon.svg');

  // Set email status for the email address
  private SetEmailStatus(emailStatus: boolean){
    let status = '';
    if(emailStatus){
      status = EmailBrandingHelper.EmailOperationalStatus;
    }else{
      status = EmailBrandingHelper.EmailBrokenStatus;
    }
    return status;
  }

  // Function to delete an email address from the email listings
  private EmitEmailAddressForDeletion(data: EmailListingsModel, domainId: number){
    if(data.IsApplied){
      this.$emit('open-alert');
    }else{
      this.$emit('delete-email-address', data, domainId);
    }
  }

  // Emit to edit an email address
  private EditEmailAddress(email: EmailListingsModel, domainId: number){
    this.$emit('edit-email-address', email, domainId);
  }

  // Functionn to set the email address as active email
  private SetEmailAsActive(data: EmailListingsModel){
    this.$emit('set-active-email', data);
  }

  private SetAppliedEmail(isActive: boolean){
    let appliedText = '';
    if(isActive){
      appliedText = EmailBrandingHelper.EmailActiveStatus;
    }
    return appliedText;
  }

}
export default toNative(EmailBrandingListings);
